import React from "react";

const Export = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="9.697" height="13" viewBox="0 0 9.697 13">
			<path
				id="icon-export"
				d="M17.2,9.088H14.427V4.5H10.271V9.088H7.5l4.849,5.353ZM7.5,15.971V17.5h9.7V15.971Z"
				transform="translate(-7.5 -4.5)"
				fill="#fff"
				opacity="0.5"
			/>
		</svg>
	);
};

export default Export;
